import { render, staticRenderFns } from "./ThePublicContent.vue?vue&type=template&id=4b3c84b8&"
import script from "./ThePublicContent.vue?vue&type=script&lang=js&"
export * from "./ThePublicContent.vue?vue&type=script&lang=js&"
import style0 from "./ThePublicContent.vue?vue&type=style&index=0&id=4b3c84b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports